export default __webpack_public_path__ + "static/media/EcfEvalHeader.c4a7d865.jpeg";